export class UserData {
  id = null;
  tag_id = null;
  locator = null;
  email = null;
  balance = null;
  tokens = null;
  blacklisted = null;
  category = null;

  constructor(
    id,
    tag_id,
    locator,
    email,
    balance,
    refundableBalance,
    tokens,
    blacklisted,
    category,
    name,
    surname,
    gender,
    birthday,
    phoneNumber,
    country,
    document,
    public_seed
  ) {
    this.id = id;
    this.tag_id = tag_id;
    this.locator = locator;
    this.email = email;
    this.balance = balance;
    this.refundableBalance = refundableBalance;
    this.tokens = tokens;
    this.blacklisted = blacklisted;
    this.category = category != null ? category : null;
    this.name = name || null;
    this.surname = surname || null;
    this.gender = gender || null;
    this.birthday = birthday || null;
    this.phoneNumber = phoneNumber || null;
    this.country = country || null;
    this.document = document || null;
    this.public_seed = public_seed || null;
  }
}
